import React, { FC, useEffect, useState } from "react";
import SolutionIcon from "../../assets/icons/Icon_Library/solutions icons/app_colouring/sol_resource_managment_fulfilment-01.svg2";
import MyIcon from "../Common/MyIcon";
import EditIcon from "../../assets/icons/edit.svg2";
import SaveIcon from "../../assets/icons/save.svg2";
import SolutionTabs from "./SolutionTabs";
import { Button } from "react-bootstrap";
import {
  useCreateSolutionMutation,
  SolutionType,
  useLazyGetSolutionByUuidQuery,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";

type ErrorMap = Record<string, string[] | null>;

interface SolutionsBuilderLandingPageProps {
  solutionUuid?: string;
}

type EditableSolution = SolutionType & {
  Monitor?: string;
};

const getEmptySolution = (): EditableSolution => ({
  Uuid: "",
  Label: "",
  Description: "",
  Reference: "",
  Version: "0.0.1",
  Kind: "standard",
  CreatedAt: 0,
  UpdatedAt: 0,
  Email: "",
  Status: "draft",
  Components: [],
  ClientSolutions: null,
  Info: {
    name: "",
    uuid: "",
    author: "",
    version: "",
    description: "",
    Dependencies: [],
    TotalActions: 0,
    ActionBreakdownPerComponent: {},
  },
  ComponentConfig: null,
  TagsMap: {
    industry: [],
    category: [],
  },
  Monitor: "none",
});

const SolutionsBuilderLandingPage: FC<SolutionsBuilderLandingPageProps> = ({
  solutionUuid,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<ErrorMap>({});
  const [createSolution] = useCreateSolutionMutation();

  const [solution, setSolution] = useState<EditableSolution>(
    getEmptySolution()
  );
  const [getSolution] = useLazyGetSolutionByUuidQuery();

  const saveSolution = async (): Promise<boolean> => {
    setLoading(true);
    setErrors({}); // Clear previous errors
    try {
      const res = await createSolution(solution);
      if ("data" in res) {
        setSolution(res.data as SolutionType);
        toast.success("Solution saved successfully");
        setLoading(false);
        return true;
      }
      if ("error" in res) {
        const error = res.error as any;
        if (error && "data" in error && error.data?.errors) {
          setErrors(error.data.errors as ErrorMap);
          toast.error("Please fix validation errors");
        } else {
          toast.error("Failed to save solution");
        }
        setLoading(false);
        return false;
      }
      setLoading(false);
      return false;
    } catch (error) {
      console.error("Error saving solution:", error);
      toast.error("Error saving solution");
      setLoading(false);
      return false;
    }
  };

  useEffect(() => {
    const fetchSolution = async () => {
      if (solutionUuid) {
        if (solutionUuid === "new") {
          setSolution(getEmptySolution());
          return;
        }
        setLoading(true);
        const res = await getSolution({ uuid: solutionUuid });
        if ("data" in res && res.data) {
          setSolution(res.data as EditableSolution);
        } else {
          toast.error("Failed to load solution");
        }
        setLoading(false);
      }
    };
    fetchSolution();
  }, [solutionUuid, getSolution]);

  console.log(solutionUuid, solution);

  return (
    <div>
      <FullScreenLoadingIndicator loading={loading} />
      <div className="mx-0 my-3 position-relative solution-builder">
        <span className="position-absolute top-0 start-50 translate-middle rounded-pill text-white py-1 px-4 text-spaced fw-bold w-auto bg-colored text-xs">
          SOLUTION
        </span>

        <div className="p-3 pt-4">
          <div className="row align-items-center">
            <div className="d-flex align-items-center col-12 col-lg-4 mt-3 mt-lg-0">
              <div className="border-end me-2">
                <MyIcon Icon={SolutionIcon} width={50} className="m-2" />
              </div>
              <div className="">
                <div className="fs-2 fw-bold text-gradient">
                  Solution Builder
                </div>
                <div className="text-secondary">
                  Create and customize your solutions to fit your unique needs.
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4 d-flex flex-column align-items-center mt-3 mt-lg-0">
              <div className="fs-2 fw-bold">
                {solution.Label || "New Solution"}
                {/* <EditIcon width={20} className="m-2 text-secondary" /> */}
              </div>
              <div className="text-secondary">
                {solution.Description || "No description provided yet."}
              </div>
            </div>
            <div className=" col-lg-4 d-flex justify-content-lg-end gap-2 align-items-end mt-3 mt-lg-0">
              {/* <Button className="bg-white border-0">
                <span>
                  <SaveIcon width={20} className="m-2 text-secondary" />
                </span>
                <span className="text-black fw-bold">EXAMPLE</span>{" "}
              </Button> */}
              <Button className="bg-white border-0" onClick={saveSolution}>
                <span>
                  <SaveIcon width={20} className="m-2 text-secondary" />
                </span>
                <span className="text-black fw-bold">SAVE</span>{" "}
              </Button>
            </div>
          </div>
        </div>
        <SolutionTabs
          solution={solution}
          setSolution={setSolution}
          saveSolution={saveSolution}
          errors={errors}
          setErrors={setErrors}
        />
      </div>
    </div>
  );
};

export default SolutionsBuilderLandingPage;
